/* ============================================================================
   CW Shrine — conversion engine.
   Cart drawer (AJAX /cart.js), sticky ATC, free-ship progress, variant picker,
   qty stepper, FAQ accordion, and a countdown that activates ONLY with a real
   future end_date (HR-URGENCIA-REAL). The ATC button opens the drawer and never
   navigates to /cart on success; on any failure it falls back to the native form
   (HR-CART-DRAWER) so the operator never sees a broken button.
   ========================================================================= */
(function () {
  "use strict";

  var CFG = (window.CW_SHRINE_CONFIG || {});
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  // Apply the scheme class (cw-shrine-config already set it on <html> in <head>;
  // mirror onto <body> for selectors that key off body, and harden the default).
  var scheme = CFG.scheme || "minimal";
  document.documentElement.classList.add("cw-" + scheme);
  if (document.body) { document.body.classList.add("cw-" + scheme); }

  function money(cents, currency) {
    var value = (Number(cents) || 0) / 100;
    // product JSON has no top-level currency; fall back to the active shop
    // currency before the hard EUR default so non-EUR stores format correctly.
    var cur = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: cur
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + " " + cur;
    }
  }

  /* ---- Cart drawer ------------------------------------------------------- */
  var drawer = { el: null, overlay: null, items: null, subtotal: null, fill: null, label: null, count: null };

  function cacheDrawer() {
    drawer.el = $("[data-cw-drawer]");
    drawer.overlay = $("[data-cw-drawer-overlay]");
    drawer.items = $("[data-cw-drawer-items]");
    drawer.subtotal = $("[data-cw-drawer-subtotal]");
    drawer.fill = $("[data-cw-progress-fill]");
    drawer.label = $("[data-cw-progress-label]");
    drawer.count = $("[data-cw-drawer-count]");
  }

  function openDrawer() {
    if (!drawer.el) { return false; }
    drawer.el.classList.add("is-open");
    if (drawer.overlay) { drawer.overlay.classList.add("is-open"); }
    drawer.el.setAttribute("aria-hidden", "false");
    return true;
  }

  function closeDrawer() {
    if (!drawer.el) { return; }
    drawer.el.classList.remove("is-open");
    if (drawer.overlay) { drawer.overlay.classList.remove("is-open"); }
    drawer.el.setAttribute("aria-hidden", "true");
  }

  function renderProgress(cart) {
    var threshold = Number(CFG.freeShipThresholdCents) || 0;
    if (!drawer.fill || !drawer.label || threshold <= 0) { return; }
    var subtotal = Number(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0;
    var pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
    drawer.fill.style.width = pct + "%";
    if (subtotal >= threshold) {
      drawer.label.textContent = drawer.label.getAttribute("data-cw-reached") || "Envio gratis desbloqueado";
    } else {
      var remaining = money(threshold - subtotal, cart.currency);
      var tmpl = drawer.label.getAttribute("data-cw-remaining") || "Te faltan {amount} para envio gratis";
      drawer.label.textContent = tmpl.replace("{amount}", remaining);
    }
  }

  function renderCart(cart) {
    if (drawer.count) { drawer.count.textContent = String(cart.item_count || 0); }
    if (drawer.items) {
      if (!cart.items || !cart.items.length) {
        var emptyMsg = drawer.items.getAttribute("data-cw-empty") || "Tu carrito esta vacio";
        drawer.items.innerHTML = '<div class="cw-drawer__empty">' + emptyMsg + "</div>";
      } else {
        drawer.items.innerHTML = cart.items.map(function (it) {
          var img = it.image ? '<img class="cw-line__img" src="' + it.image + '" alt="" loading="lazy">' : '<span class="cw-line__img"></span>';
          return '<div class="cw-line">' + img +
            '<div class="cw-line__meta"><div class="cw-line__name">' + escapeHtml(it.product_title) +
            '</div><div class="cw-line__price">' + it.quantity + " x " + money(it.final_price, cart.currency) +
            "</div></div></div>";
        }).join("");
      }
    }
    if (drawer.subtotal) { drawer.subtotal.textContent = money(cart.total_price, cart.currency); }
    renderProgress(cart);
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function refreshCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  // HR-CART-DRAWER: ATC adds via AJAX and opens the drawer; never navigates to
  // /cart on success. On ANY failure, submit the native form (which adds + lands
  // on /cart) so the operator never loses the add or sees a broken button.
  function wireAtcForms() {
    $all("form[data-cw-atc]").forEach(function (form) {
      form.addEventListener("submit", function (ev) {
        ev.preventDefault();
        var fd = new FormData(form);
        fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
          .then(function (r) {
            if (!r.ok) { throw new Error("add failed " + r.status); }
            return r.json();
          })
          .then(function () { return refreshCart(); })
          .then(function () {
            if (!openDrawer()) { window.location.href = "/cart"; }
          })
          .catch(function () {
            // Silent fallback — native submit performs the add and redirects to /cart.
            form.submit();
          });
      });
    });
  }

  function wireDrawerControls() {
    $all("[data-cw-drawer-close]").forEach(function (b) {
      b.addEventListener("click", closeDrawer);
    });
    if (drawer.overlay) { drawer.overlay.addEventListener("click", closeDrawer); }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeDrawer(); }
    });
    $all("[data-cw-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        refreshCart().then(openDrawer);
      });
    });
  }

  /* ---- Sticky ATC ------------------------------------------------------- */
  function wireStickyAtc() {
    var sticky = $("[data-cw-sticky-atc]");
    var anchor = $("[data-cw-main-atc]");
    if (!sticky || !anchor || !("IntersectionObserver" in window)) { return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show the sticky bar only once the main ATC has scrolled out of view.
        if (entry.isIntersecting) { sticky.classList.remove("is-visible"); }
        else { sticky.classList.add("is-visible"); }
      });
    }, { rootMargin: "0px", threshold: 0 });
    obs.observe(anchor);
    var stickyBtn = $("[data-cw-sticky-add]", sticky);
    if (stickyBtn) {
      stickyBtn.addEventListener("click", function (e) {
        e.preventDefault();
        var mainForm = anchor.closest("form[data-cw-atc]") || $("form[data-cw-atc]");
        if (mainForm) {
          if (typeof mainForm.requestSubmit === "function") { mainForm.requestSubmit(); }
          else { mainForm.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true })); }
        } else {
          window.location.href = "/cart";
        }
      });
    }
  }

  /* ---- Variant picker --------------------------------------------------- */
  function wireVariantPicker() {
    var root = $("[data-cw-variant-picker]");
    if (!root) { return; }
    var dataEl = $("[data-cw-product-json]", root) || $("[data-cw-product-json]");
    var product;
    try { product = JSON.parse(dataEl ? dataEl.textContent : "null"); } catch (e) { product = null; }
    if (!product || !product.variants) { return; }
    var hidden = $("[data-cw-variant-id]", root);
    var priceNow = $("[data-cw-price-now]", root) || $("[data-cw-price-now]");
    var selected = {};

    function findVariant() {
      var opts = product.variants;
      for (var i = 0; i < opts.length; i++) {
        var v = opts[i];
        var match = true;
        Object.keys(selected).forEach(function (k) {
          if (String(v["option" + k]) !== String(selected[k])) { match = false; }
        });
        if (match) { return v; }
      }
      return null;
    }

    function apply() {
      var v = findVariant();
      if (!v) { return; }
      if (hidden) { hidden.value = v.id; }
      if (priceNow) { priceNow.textContent = money(v.price, product.currency); }
      root.setAttribute("data-cw-available", v.available ? "true" : "false");
    }

    $all("[data-cw-opt]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = btn.getAttribute("data-cw-opt");
        selected[idx] = btn.getAttribute("data-cw-value");
        var group = btn.parentElement;
        $all("[data-cw-opt='" + idx + "']", group).forEach(function (sib) { sib.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        apply();
      });
    });
  }

  /* ---- Quantity stepper ------------------------------------------------- */
  function wireQty() {
    $all("[data-cw-qty]").forEach(function (box) {
      var input = $("input", box);
      if (!input) { return; }
      $all("[data-cw-qty-step]", box).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = parseInt(btn.getAttribute("data-cw-qty-step"), 10) || 0;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = String(next);
        });
      });
    });
  }

  /* ---- FAQ accordion ---------------------------------------------------- */
  function wireFaq() {
    $all("[data-cw-faq] .cw-faq__q").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.closest(".cw-faq__item");
        if (item) { item.classList.toggle("is-open"); }
      });
    });
  }

  /* ---- Countdown (HR-URGENCIA-REAL) ------------------------------------- */
  function wireCountdown() {
    var el = $("[data-cw-countdown]");
    if (!el) { return; }
    var raw = CFG.countdownEndDate;
    if (!raw) { return; }                         // no real date -> never render
    var end = Date.parse(raw);
    if (isNaN(end) || end <= Date.now()) { return; } // past/invalid -> never render
    var out = $("[data-cw-countdown-t]", el) || el;
    el.classList.add("is-active");
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.classList.remove("is-active"); return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var pad = function (n) { return (n < 10 ? "0" : "") + n; };
      out.textContent = (d > 0 ? d + "d " : "") + pad(h) + ":" + pad(m) + ":" + pad(s);
      window.setTimeout(tick, 1000);
    }
    tick();
  }

  function init() {
    cacheDrawer();
    wireAtcForms();
    wireDrawerControls();
    wireStickyAtc();
    wireVariantPicker();
    wireQty();
    wireFaq();
    wireCountdown();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Expose a tiny API for the sticky bar / tests.
  window.CWShrine = { openDrawer: openDrawer, closeDrawer: closeDrawer, refreshCart: refreshCart };
})();
